import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth, ensureAuth } from './firebase';

const functions = getFunctions(undefined, 'us-central1');

export type StakeholderClaimsState = {
  isStakeholder: boolean;
  displayName: string | null;
  companyName: string | null;
  portalId: string | null;
  leadId: string | null;
  linkId: string | null;
};

export async function verifyStakeholderTokenCallable(params: {
  token: string;
  portalId?: string;
  proposalId?: string;
}): Promise<{
  displayName: string;
  companyName?: string;
  portalId: string;
  portalSlug: string;
  leadId?: string;
  purpose?: string;
}> {
  await ensureAuth();
  const fn = httpsCallable(functions, 'verifyStakeholderToken');
  const res = await fn(params);
  await auth.currentUser?.getIdToken(true);
  return res.data as {
    displayName: string;
    companyName?: string;
    portalId: string;
    portalSlug: string;
    leadId?: string;
    purpose?: string;
  };
}

export async function clearStakeholderSessionCallable(): Promise<void> {
  await ensureAuth();
  const fn = httpsCallable(functions, 'clearStakeholderSession');
  await fn({});
  await auth.currentUser?.getIdToken(true);
}

export async function readStakeholderClaimsFromToken(): Promise<StakeholderClaimsState> {
  const u = auth.currentUser;
  if (!u) {
    return {
      isStakeholder: false,
      displayName: null,
      companyName: null,
      portalId: null,
      leadId: null,
      linkId: null,
    };
  }
  const r = await u.getIdTokenResult();
  const c = r.claims as Record<string, unknown>;
  if (c.stakeholderReadOnly === true && c.stakeholderPortalId) {
    return {
      isStakeholder: true,
      displayName: typeof c.stakeholderName === 'string' ? c.stakeholderName : null,
      companyName: typeof c.stakeholderCompany === 'string' && c.stakeholderCompany.trim()
        ? c.stakeholderCompany.trim()
        : null,
      portalId: typeof c.stakeholderPortalId === 'string' ? c.stakeholderPortalId : null,
      leadId: typeof c.stakeholderLeadId === 'string' && c.stakeholderLeadId
        ? c.stakeholderLeadId
        : null,
      linkId: typeof c.stakeholderLinkId === 'string' && c.stakeholderLinkId
        ? c.stakeholderLinkId
        : null,
    };
  }
  return {
    isStakeholder: false,
    displayName: null,
    companyName: null,
    portalId: null,
    leadId: null,
    linkId: null,
  };
}

/** Append stakeholder token to query params when building portal child URLs. */
export function appendStakeholderParam(
  searchParams: URLSearchParams,
  token: string | null
): string {
  const p = new URLSearchParams(searchParams);
  if (token) {
    p.set('stakeholderToken', token);
  } else {
    p.delete('stakeholderToken');
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}
